export enum MarginEventType {

    MarginCall = 1,
    Liquidation = 2,
}
